import { AxiosResponse } from 'axios';
import moment from 'moment';
import { FinalTermType } from '../app';
import { FinalTermDto, ValidationRuleDto } from '../dto';
import { LeiCategory } from '../../../constants';

export const cleanFinalTermDtoObject = (object: FinalTermDto): FinalTermDto => {
  const clone = JSON.parse(JSON.stringify(object));

  if (object.file) {
    clone.file = object.file;
  }

  Object.keys(clone).forEach((key) => {
    if (clone[key] && typeof clone[key] === 'object') {
      cleanFinalTermDtoObject(clone[key]);
    } else if (clone[key] === undefined) {
      delete clone[key];
    }
  });

  return clone;
};

export const mapFinalTermTypeToDto = (fields: FinalTermType): FinalTermDto => {
  const mappedFields: FinalTermDto = {
    finalTerm: {
      relatedRequestId: fields.baseProspectus.fileNumber,
      relatedRequestDateOfApproval: moment(fields.baseProspectus.dateOfApproval).format('yyyy-MM-DD'),
      language: fields.finalTermsDetails.language,
      date: moment(fields.finalTermsDetails.date).format('yyyy-MM-DD'),
      euGreenBonds: fields.finalTermsDetails.euGreenBonds,
      bondMarketedAsEnvSys: fields.finalTermsDetails.bondMarketedAsEnvSys,
      susLinkedBonds: fields.finalTermsDetails.susLinkedBonds,
      securities: fields.securities.map((security) => ({
        orderNumber: security.orderNumber,
        fisn: security.fisn,
        isin: security.isin,
        cfi: security.cfiCode,
        unitDenomination: security.denominationPerUnit?.toString(),
        customUnderlyingIdentifier: security.underlying?.nameOrIsin,
        endDate: security.maturityDate ? moment(security.maturityDate).format('yyyy-MM-DD') : undefined,
        offerEndDate: security.offerEndDate ? moment(security.offerEndDate).format('yyyy-MM-DD') : undefined,
        bailInAbility: security.bailInAbility,
        currency: security.issuanceCurrency,
        type: security.type,
        underlyingType: security.underlying?.identifier,
        admissionType: security.typeOfOfferAdmission,
        tradingCharacteristic: security.tradingVenueCharacteristics,
        volumeFrom: security.volume?.from?.toString(),
        volumeTo: security.volume?.to?.toString(),
        volume: security.volume?.equal?.toString(),
        priceOfferedFrom: security.price?.from?.toString(),
        priceOfferedTo: security.price?.to?.toString(),
        priceOffered: security.price?.equal?.toString(),
        priceOfferedPending: security.price?.pending,
        considerationOfferedFrom: security.consideration?.from?.toString(),
        considerationOfferedTo: security.consideration?.to?.toString(),
        considerationOffered: security.consideration?.equal?.toString(),
        considerationOfferedPending: security.consideration?.pending,
        publicOffer: security.offerToPublic,
        offerMemberStates:
          security.memberStateOfferToPublic && Array.isArray(security.memberStateOfferToPublic)
            ? security.memberStateOfferToPublic?.map((memberState) => memberState)
            : [],
        admissionMemberStates:
          security.memberStateAdmissionToTrading && Array.isArray(security.memberStateAdmissionToTrading)
            ? security.memberStateAdmissionToTrading?.map((memberState) => memberState)
            : [],
      })),
      legalEntities: [
        ...fields.finalTermsDetails.leiIssuers.map((issuer) => ({
          lei: issuer.lei,
          category: LeiCategory.ISSUER,
        })),
        ...fields.finalTermsDetails.leiGuarantors.map((issuer) => ({
          lei: issuer.lei,
          category: LeiCategory.GUARANTOR,
        })),
      ],
      contact: {
        ...fields.contact,
      },
    },
    file: fields.file,
  };

  return cleanFinalTermDtoObject(mappedFields);
};

export const parseValidationResponseToDto = ({ data }: AxiosResponse<any>): ValidationRuleDto[] => {
  return (
    data.validations &&
    data.validations.map((validation: any) => ({
      entities: validation.entities,
      internal: validation.internal,
      message: validation.message,
      statuses: validation.statuses,
      validationRule: validation.validationRule,
      validationRuleDisplayZone: validation.validationRuleDisplayZone,
      validationRuleGroup: validation.validationRuleGroup,
      validationRuleLevel: validation.validationRuleLevel,
    }))
  );
};
